import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-refund-page',
  templateUrl: './refund-page.component.html',
  styleUrls: ['./refund-page.component.css']
})
export class RefundPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
